<script lang="ts" setup>
  import Clarity from '@microsoft/clarity';
  import { storeToRefs } from 'pinia';
  import { onBeforeMount, onMounted, watch } from 'vue';

  import BasicLayout from '@/layout/main/BasicLayout.vue';
  import { useAuthStore } from '@/stores/auth.store';
  import { useLocaleStore } from '@/stores/locale.store';
  import { useNotificationsStore } from '@/stores/notifications.store';
  import { useOrganizationStore } from '@/stores/organzation.pinia';
  import NotFound from '@/views/misc/NotFound.vue';

  import SnackbarVue from '@/components/misc/snackbar.vue';

  const { isLTR } = storeToRefs(useLocaleStore());
  const authStore = useAuthStore();
  const { getOrganizationLearningCategories, getOrganizationDynamicPages } =
    useOrganizationStore();
  const { dynamicPagesEnabled } = storeToRefs(useOrganizationStore());
  const getDynamicPage = () => {
    if (dynamicPagesEnabled.value) return getOrganizationDynamicPages();
  };
  onBeforeMount(async () => {
    await Promise.all([
      //if there other stores or functions to initialize, add them here
      authStore.initializeAuth(),
      getDynamicPage(),
      getOrganizationLearningCategories({
        skip: 0,
        take: Number.MAX_SAFE_INTEGER,
      }),
    ]);
  });
  const { organizationPages } = storeToRefs(useOrganizationStore());
  const assignFontFamily = () => {
    const overlayContainer = document.querySelector('body');

    if (overlayContainer) {
      if (isLTR.value) {
        overlayContainer.classList.remove('ar');
        overlayContainer.classList.add('en');
      } else {
        overlayContainer.classList.remove('en');
        overlayContainer.classList.add('ar');
      }
    }
  };
  onMounted(() => {
    assignFontFamily();
  });
  watch(
    () => isLTR.value,
    () => {
      assignFontFamily();
      if (authStore.user?.id) useNotificationsStore().getNotifications();
    }
  );
  const organizationStore = useOrganizationStore();
  const { organizationNotFound, clarityProjectId } =
    storeToRefs(organizationStore);
  if (clarityProjectId.value) {
    Clarity.init(clarityProjectId.value);
  }
</script>

<template>
  <v-app class="bg-app">
    <NotFound v-if="organizationNotFound" no-redirect />
    <template v-else>
      <BasicLayout></BasicLayout>
      <SnackbarVue />
    </template>
  </v-app>
</template>
